import { ID } from '@models';
import useFetch from '@hooks/useFetch';
import { useEffect, useMemo, useState } from 'react';
import { components } from '@api/api';
import { iItem, Item } from '@models/Item';
import { useChainProfileFilters } from '@core/selectors/useChainProfileFilters';
import { useUserContext } from "@core/UserContext";

export function useChainProfileRecentlyReleasedItems(chainId: ID) {
    const { uiSettings: { currencySymbol }} = useUserContext();
    const [data, setData] = useState<iItem[]>([]);

    const filter = useChainProfileFilters();

    const payload = useMemo((): components['schemas']['ChainProfileRecentlyReleasedItemsRequest'] => {
        return {
            id: chainId as number,
            filter,
            page: {
                currentPage: 1,
                perPage: 100,
            }
        };
    }, [filter, chainId]);

    const result = useFetch<components['schemas']['ChainProfileRecentlyReleasedItemsResponse']>({
        url: '/api/ChainProfile/RecentlyReleasedItems',
        method: 'post',
        payload,
    });

    useEffect(() => {
        if (!result.isLoading) {
            setData((result.data?.items || []).map(i => new Item({ apiModel: i, currencySymbol })))
        }
    }, [result.isLoading, result.data, currencySymbol]);

    return {
        isLoading: result.isLoading,
        data,
    }
}